export {
  SubCheckoutPage as SubCheckoutPageV2,
  type SubCheckoutPageV2Props,
  SubCheckoutV2Step,
} from "./SubCheckoutPage";
